<template>
    <svg class="img-fluid" viewBox="0 0 1020 480" ref="svg">
        <foreignObject width="1020" height="480" :style="backgroundStyle">
            <div style="width: 1020px;height: 480px;overflow: hidden" :style="safariStyleFix">
                <div class="p-0 m-0">
                    <div class="container p-0 px-md-5 pt-sm-3 pt-md-5 pb-5">
                        <div class="card border-0 rounded-0 shadow-lg h-100 mb-3">
                            <div class="card-header d-flex flex-column flex-sm-row align-items-stretch bg-theme rounded-0 border-bottom align-items-sm-center p-0">
                                <div v-if="election.theme.logo" class="bg-light p-3 align-self-stretch d-flex align-items-center">
                                    <img :src="election.theme.logo" style="max-height:50px;max-width:100%" />
                                </div>
                                <div class="d-flex align-items-center justify-content-between p-3">
                                    <h3 class="mb-0">{{ election.title[firstAvailableLocale] }}</h3>
                                </div>
                            </div>
                            <div class="card-body h-100 p-3 p-md-5">
                                <template v-if="!isBallot">
                                    <template v-if="slide.layout === 'header_with_text'">
                                        <header class="h1 text-center">{{title}}</header>
                                        <div class="lead mb-3 text-left" v-html="description"></div>
                                    </template>
                                    <template v-else-if="slide.layout === 'header_with_image'">
                                        <header class="h1 text-center">{{title}}</header>
                                        <img :src="image" class="img-fluid">
                                    </template>
                                    <template v-else-if="slide.layout === 'single_image'">
                                        <img :src="image" class="img-fluid">
                                    </template>
                                </template>
                                <template v-if="isBallot">
                                    <header class="h1 text-center">{{title}}</header>
                                    <div class="lead mb-3 text-left" v-html="description"></div>
                                    <div class="ballot mt-3 text-left">
                                        <div v-for="option in slide.options" class="option p-3 mb-3 border">
                                            <span class="h5">{{option.title[firstAvailableLocale] }}</span>
                                            <div v-html="option.description[firstAvailableLocale]"></div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </foreignObject>
    </svg>
</template>
<script>
    import {mapGetters, mapState} from "vuex"

    export default {
        name: 'PreviewSlide',
        props: {
            slide: {
                type: Object,
                required: false,
                default: ()=>{
                    return {type: 'none'}
                }
            },
        },
        data() {
            return {
                svg: {
                    type: Object,
                    default: null
                }
            }
        },
        computed: {
            ...mapState(['election', 'electionUrl']),
            ...mapGetters(['firstAvailableLocale']),
            title(){
                return this.slide.title[this.firstAvailableLocale];
            },
            description(){
                return this.slide.description[this.firstAvailableLocale];
            },
            isBallot(){
                return this.slide.type === 'Slides::BallotSlide';
            },
            image(){
                return this.slide.image;
            },
            safariStyleFix(){
                let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
                if(isSafari){
                    let scale = (this.svg ? this.svg.clientWidth : 200) / 1020
                    return {
                        'transform': `scale(${scale})`,
                        'transform-origin': 'top left'
                    }
                }
                return {}
            },
            backgroundStyle(){
                if (this.slide.background) {
                    return {
                        backgroundImage: `url('${this.slide.background}')`,
                        backgroundAttachment: 'local',
                        backgroundSize: 'cover'
                    };
                } else {
                    return {backgroundColor: '#fff'}
                }
            },
        },
        mounted() {
            this.svg = this.$refs.svg;
        }
    }
</script>